import React from 'react';

import { observer } from 'mobx-react';
import { TitleWithDescription, Radio } from '@infoods/lifebase-ui';

import classes from './ChallengeInfoCard.module.scss';
import { SelectableCard } from '../../../../../../../../shared/components/form-components';
import { getPriceView } from '../../../../../../../../shared/utils/stringUtils';
import { challengeSignUpStore } from '../../../../../../../stores/challengeSignUpStore';
import { getFormattedDateInTz } from '../../../../../../../../shared/utils/timezoneUtils/getFormattedDateInTz';
import { localDataFormat } from '../../../../../../../../shared/constants/apiDateFormat';
import { DISCOUNT_TYPE } from '../../../../../../../../payment/constants/discountType';
import { DiscountChip } from '../../../../../../../../payment/components/DiscountChip/DiscountChip';

const ChallengeInfoCard = observer(() => {
  const { challengePaymentInfo, appliedPromoCode } = challengeSignUpStore;

  if (!challengePaymentInfo) {
    return null;
  }

  const formattedStartDate = getFormattedDateInTz(
    challengePaymentInfo.challengeStartDate,
    challengePaymentInfo.timeZone,
    localDataFormat,
  );
  const formattedEndDate = getFormattedDateInTz(
    challengePaymentInfo.challengeEndDate,
    challengePaymentInfo.timeZone,
    localDataFormat,
  );

  const shouldShowDiscount =
    appliedPromoCode && challengePaymentInfo.discountType === DISCOUNT_TYPE.PROMOCODE;

  return (
    <SelectableCard className={classes.container}>
      <Radio checked />
      <div className={classes.content}>
        <TitleWithDescription
          title={
            <div className={classes.titleContainer}>
              {challengePaymentInfo.challengeName}
              <DiscountChip
                show={!!shouldShowDiscount}
                discountPercent={appliedPromoCode?.discountPercent}
                className={classes.discountChip}
              />
            </div>
          }
          description={`${formattedStartDate} - ${formattedEndDate}`}
        />
        <div className={classes.priceInfo}>
          <div className={classes.priceContainer}>
            {challengePaymentInfo.price !== challengePaymentInfo.priceFinal && (
              <p className={classes.oldPrice}>
                {getPriceView(challengePaymentInfo.price)}
              </p>
            )}
            <p className={classes.price}>
              {getPriceView(challengePaymentInfo.priceFinal)}
            </p>
          </div>
          <p className={classes.paymentType}>One-Time Payment</p>
        </div>
      </div>
    </SelectableCard>
  );
});

export { ChallengeInfoCard };
